//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalCertificationAdminStore = hookstate({
});

export default globalCertificationAdminStore;